import React from 'react';
import { Camera, Monitor, MessageCircle, Shield, QrCode, Heart, Users, Clock } from 'lucide-react';
// import StyledCard from '../../ui/overlays/StyledCard';
import qrcodeImg from '../../../img/wedding1.jpg';
import wedding2Img from '../../../img/wedding2.jpg';
import heartImg from '../../../img/wedding4.jpg';
import wedding3Img from '../../../img/wedding3.jpg';

const FeatureIntro: React.FC = () => {
  const features = [
    {
      icon: <QrCode size={32} />,
      title: "QRコード簡単アクセス",
      description: "参列者はQRコードをスキャンするだけで、\nすぐ写真投稿ページへアクセスできます。\nアプリのインストールも不要で、\nどなたでも簡単にご利用いただけます。",
      benefits: ["アプリ不要", "瞬時アクセス", "全年齢対応"],
      image: qrcodeImg,
      imageAlt: "QRコードによる簡単アクセスのイメージ"
    },
    {
      icon: <Monitor size={32} />,
      title: "リアルタイム投影",
      description: "アップロードされた写真やコメントが、\nリアルタイムでスクリーンに表示されます。\n式の進行に合わせて、\n感動の瞬間を会場全体で共有できます。",
      benefits: ["即座反映", "大画面表示", "感動演出"],
      image: wedding2Img,
      imageAlt: "結婚式会場でのリアルタイム投影のイメージ"
    },
    {
      icon: <MessageCircle size={32} />,
      title: "コメント・いいね機能",
      description: "写真にコメントやいいねを付けることで、\n参列者同士の交流が生まれます。\n新郎新婦への祝福メッセージも\n画面上で美しく表示されます。",
      benefits: ["交流促進", "祝福共有", "思い出深化"],
      image: heartImg,
      imageAlt: "コメントといいね機能で交流する参列者のイメージ"
    },
    {
      icon: <Shield size={32} />,
      title: "安心のモデレーション",
      description: "式場スタッフによる事前承認機能で、\n不適切なコンテンツをしっかりと防ぎます。\n安心して大切な結婚式をお楽しみいただけます",
      benefits: ["事前チェック", "安全運営", "品質保証"],
      image: wedding3Img,
      imageAlt: "安心のモデレーション機能のイメージ"
    }
  ];

  return (
    <section className="features-section">
      <div className="section-header">
        <div className="title-decoration">
          <div className="decoration-line"></div>
          <Heart className="section-heart" />
          <div className="decoration-line"></div>
        </div>
        <p className="features-subtitle">
          式場運営に最適化された <br />4つの主要機能で <br />忘れられない結婚式を演出します
        </p>
      </div>

      <div className="features-container">
        {features.map((feature, index) => (
          <div key={index} className="feature-fullscreen">
            <div className={`feature-content ${index % 2 === 1 ? 'reverse' : ''}`}>
              <div className="feature-text">
                <div className="feature-number">0{index + 1}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className="feature-benefits">
                  {feature.benefits.map((benefit, benefitIndex) => (
                    <span key={benefitIndex} className="benefit-tag">
                      {benefit}
                    </span>
                  ))}
                </div>
              </div>
              <div className="feature-visual">
                <img 
                  src={feature.image} 
                  alt={feature.imageAlt}
                  className="feature-image"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureIntro;